<template>
  <Popup position="top" v-model:show="show" :style="{ height: '50%', top: `${statusBarHeight}px` }">
    <div class="ws-lang-pop">
      <ul>
        <li v-for="(item, index) in langList" key="index" @click="onClickItem(item)">
          {{ item.name }}
          <van-icon v-if="wsLocaleLang.short === item.short " name="success" color="#F1B645"  />
        </li>
      </ul>
    </div>
  </Popup>
</template>
<script setup>
import { computed } from 'vue';
import { Popup } from 'vant'
import { useMsgStore } from '@/states/msg';
import { wsLangSetting } from '@/composables/use-ws-lang'
import { showFailToast, showToast ,showLoadingToast, closeToast} from 'vant'
import { useEnvStore } from '@/states/env'
import { useUserStore } from '@/states/user'

const { statusBarHeight } = useEnvStore()

const msgStore = useMsgStore();
const { wsI18nLangStore, updateWsLangByKey, wsLocaleLang } = wsLangSetting()

const langList = computed(() => {
  return Object.keys(wsI18nLangStore).map(key => wsI18nLangStore[key]);
});
const isLogin = useUserStore().isLogin

const props = defineProps({
  visible: {
    default: false,
    type: Boolean
  },
  // reviewMessage: {
  //   default: () => ({}),
  //   type: Object
  // }
})

const emits = defineEmits(['closePop']);

const show = defineModel("show", { default: true });

const onClickItem = async (item) => {
  if (!isLogin) {
    updateWsLangByKey(item.key, true)
    emits('closePop')
    return
  }
  showLoadingToast({
    forbidClick: true,
    message: 'loading...',
  })
  const {ackStatus} = await msgStore.modifyWsLang(item.short)
  closeToast()
  if (ackStatus === 'SUCCESS') {
    updateWsLangByKey(item.key)
    emits('closePop')
  } else {
    showFailToast('fail')
  }
}

</script>
<style scoped lang="scss">
.ws-lang-pop {
  background-color: #fff;
  height: 100%;

  ul {
    font-size: 14px;
    color: #333333;
  }

  li {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    margin: 0 10px;
    border-bottom: 1px solid #E9E9E9;

    &:last-child{
      border-bottom: 0;
    }
  }
}
</style>